import { AiOutlineWifi } from "react-icons/ai";
import { BsCheckCircle, BsAlarm } from "react-icons/bs";
import { WorkOutline, PeopleOutline } from "@material-ui/icons";
import { MdLocalBar, MdRestaurant, MdSmokeFree } from "react-icons/md";
import { FaSwimmingPool, FaLuggageCart } from "react-icons/fa";
import { FiCoffee } from "react-icons/fi";
import { RiExchangeDollarLine } from "react-icons/ri";
import { GiWineGlass, GiRunningShoe, GiStairs } from "react-icons/gi";
export const heatFacility = [
  {
    icon: AiOutlineWifi,
    label: "有可供無線上網的公共區域",
  },
  {
    icon: MdLocalBar,
    label: "酒吧",
  },
  {
    icon: PeopleOutline,
    label: "24小時櫃檯服務",
  },
  {
    icon: FaSwimmingPool,
    label: "室內游泳池",
  },
  {
    icon: GiStairs,
    label: "行政樓層",
  },
  {
    icon: MdRestaurant,
    label: "餐廳",
  },
  {
    icon: MdSmokeFree,
    label: "無煙樓層",
  },
  {
    icon: BsAlarm,
    label: "喚醒服務",
  },
  {
    icon: FaLuggageCart,
    label: "行李寄存",
  },
  {
    icon: WorkOutline,
    label: "商務服務",
  },
  {
    icon: FiCoffee,
    label: "咖啡廳",
  },
  {
    icon: RiExchangeDollarLine,
    label: "外幣兌換服務",
  },
  {
    icon: GiRunningShoe,
    label: "健身中心",
  },
  {
    icon: GiWineGlass,
    label: "行政酒廊",
  },
];

export const network = {
  icon: BsCheckCircle,
  label: "有可供無線上網的公共區域",
};

export const customerService = [
  {
    icon: BsCheckCircle,
    label: "行李員",
  },
  {
    icon: BsCheckCircle,
    label: "禮賓服務",
  },
  {
    icon: BsCheckCircle,
    label: "外幣兌換服務",
  },
  {
    icon: BsCheckCircle,
    label: "旅遊地圖",
  },
  {
    icon: BsCheckCircle,
    label: "行李寄存",
  },
  {
    icon: BsCheckCircle,
    label: "喚醒服務",
  },
  {
    icon: BsCheckCircle,
    label: "24小時櫃檯服務",
  },
  {
    icon: BsCheckCircle,
    label: "一次性帳單結算服務",
  },
  {
    icon: BsCheckCircle,
    label: "24小時大堂經理",
  },
  {
    icon: BsCheckCircle,
    label: "信用卡結算服務",
  },
  {
    icon: BsCheckCircle,
    label: "門童",
  },
];

export const mealService = [
  {
    icon: BsCheckCircle,
    label: "餐廳",
  },
  {
    icon: BsCheckCircle,
    label: "酒吧",
  },
  {
    icon: BsCheckCircle,
    label: "咖啡廳",
  },
  {
    icon: BsCheckCircle,
    label: "送餐服務",
  },
];

export const normalFacility = [
  {
    icon: BsCheckCircle,
    label: "電梯",
  },
  {
    icon: BsCheckCircle,
    label: "無障礙客房",
  },
  {
    icon: BsCheckCircle,
    label: "公共空間閉路電視監控系統",
  },
  {
    icon: BsCheckCircle,
    label: "行政樓層",
  },
  {
    icon: BsCheckCircle,
    label: "大堂報紙",
  },
  {
    icon: BsCheckCircle,
    label: "行政酒廊",
  },
  {
    icon: BsCheckCircle,
    label: "無煙樓層",
  },
];

export const reminder = [
  {
    title: "重要提示",
    content: [
      "入住時必需出示有效通行證或護照辦理入住手續。",
      "酒店不接受添加或修改入住人姓名。",
      "所有殘障客房之要求，必須在訂房時預先與酒店訂房部提出，並要經酒店確認後方可保留此類客房。未經確認或客人抵店時才提出要求, 均不獲酒店安排。",
      "所有已過最晚修改取消時間的訂單不接受任何更改，包括入住日期及姓名。",
    ],
  },
  {
    title: "重要城市資訊",
    content: ["未滿18歲的小孩需有成人陪同才可入住。"],
  },
  {
    title: "酒店提示",
    content: [
      "酒店泳池將會在2019年12月09日起，暫時關閉進行緊急維修，直至另行通知，造成的不便我們深感抱歉。[2019年12月9日 - 2020年12月31日]",
      "根據酒店通知，酒店不適宜用作檢疫隔離，故無法接待所有於抵港前14日曾到任何海外國家/屬地的賓客入住，以確保一個安全及健康的環境。感謝您的理解。[2020年4月28日 - 2020年7月31日]",
    ],
  },
];
